const speakerSpeed = 'speakerSpeed';
const isDefaultEmphasizeKey = 'isDefaultEmphasize';
const cameraDeviceIdKey = 'cameraDeviceId';

/**
 * 発話速度を保存
 */
export function setSpeakerSpeed(value: number): void {
    localStorage.setItem(speakerSpeed, value.toString());
}

/**
 * 発話速度を返却
 * 値がなければ引数に渡された値を返却する。
 */
export function getSpeakerSpeed(defaultVal: number): number {
    const val = localStorage.getItem(speakerSpeed);
    return val === null ? defaultVal : parseFloat(val);
}

/**
 * 画像の初期表示を刻印強調にするフラグを保存
 */
export function setIsDefaultEmphasize(value: boolean): void {
    localStorage.setItem(isDefaultEmphasizeKey, value.toString());
}

/**
 * 画像の初期表示を刻印強調にするかどうかのフラグを返却
 * ローカルストレージにデータがなければfalseを返却する
 */
export function getIsDefaultEmphasize(): boolean {
    const val = localStorage.getItem(isDefaultEmphasizeKey);
    return val === null ? false : val === 'true';
}


/**
 * バーコード読取に利用するカメラのデバイスIDを保存
 */
export function setCameraDeviceId(value: string): void {
    localStorage.setItem(cameraDeviceIdKey, value);
}

/**
 * バーコード読取に利用するカメラのデバイスIDを返却
 * ローカルストレージにデータがなければnullを返却する
 */
export function getCameraDeviceId(): string | null{
    const val = localStorage.getItem(cameraDeviceIdKey);
    return val;
}